export default {
    mounted(el, binding) {
        const handler = (event) => {
            if (!(event.target instanceof Element) || el.contains(event.target)) {
                return;
            }
            if (typeof binding.value === 'function') {
                binding.value(false);
            }
        };
        el.__outHandler__ = handler;
        document.addEventListener('click', handler, true);
    },

    unmounted(el) {
        if (!el.__outHandler__) {
            return;
        }
        document.removeEventListener('click', el.__outHandler__, true);
        delete el.__outHandler__;
    },
};
